import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 120 120">
    <title>Hedi Hidouri Logo</title>
    <path
      d="M60 8C88.719 8 112 31.281 112 60C112 88.719 88.719 112 60 112C31.281 112 8 88.719 8 60C8 31.281 31.281 8 60 8Z"
      stroke="#ffffff"
      strokeWidth="6"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 33V87"
      stroke="#ffffff"
      strokeWidth="8"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M82 33V87"
      stroke="#ffffff"
      strokeWidth="8"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 56L82 40"
      stroke="#ffffff"
      strokeWidth="7"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38 80L82 64"
      stroke="#ffffff"
      strokeWidth="7"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default IconLogo;
